import type { SearchFieldDetailApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { FieldConfiguration } from '@ingenico/react-ui/advanced-search';
import { validFieldConfigurationTypes } from '@ingenico/react-ui/advanced-search';

export function mapFromSearchFieldDetailToFieldConfiguration(response: SearchFieldDetailApi[]): FieldConfiguration[] {
  return response.map(({ key, type }) => ({
    key,
    type: validFieldConfigurationTypes.includes(type as string) ? type : 'string',
    visible: true,
    searchable: !key.includes('parent'),
  })) as FieldConfiguration[];
}
